var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39724 16.5165L3.70359 18.7809C3.60793 18.8613 3.4913 18.9127 3.36741 18.9291C3.24352 18.9455 3.11752 18.9262 3.00424 18.8734C2.89095 18.8207 2.79509 18.7367 2.72791 18.6313C2.66074 18.5259 2.62506 18.4035 2.62506 18.2786V5.25005C2.62506 5.076 2.6942 4.90908 2.81727 4.78601C2.94034 4.66294 3.10726 4.5938 3.28131 4.5938H17.7188C17.8929 4.5938 18.0598 4.66294 18.1829 4.78601C18.3059 4.90908 18.3751 5.076 18.3751 5.25005V15.75C18.3751 15.9241 18.3059 16.091 18.1829 16.2141C18.0598 16.3372 17.8929 16.4063 17.7188 16.4063H6.69963L6.39724 16.5165Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87506 9.1875H13.1251",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87506 11.8125H13.1251",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.1167c8251b58a839cb592e9abeb5a17c.svg";
export { ForwardRef as ReactComponent };